import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ManagerService } from 'src/app/core';

@Component({
  selector: 'app-product-booking-drawer',
  templateUrl: './product-booking-drawer.component.html',
  styleUrls: ['./product-booking-drawer.component.scss']
})
export class ProductBookingDrawerComponent implements OnInit, OnChanges {

  @Input() challenge: any;
  @Input() isOpen = false;
  @Output() closed = new EventEmitter<void>();

  showProofModal = false;

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  bookingProgress: any = null;
  bookingLoading: boolean = false;

  constructor(private managerService: ManagerService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && changes['isOpen'].currentValue === true) {
      this.loadBookingProgress();
    }
  }

  loadBookingProgress() {
    if (!this.challenge || !this.challenge.userChallengeId) { return; }
    this.bookingLoading = true;
    this.bookingProgress = null;
    this.managerService.getProductBookingProgress(this.challenge.userChallengeId).subscribe(
      (data: any) => {
        this.bookingProgress = data;
        this.bookingLoading = false;
      },
      () => { this.bookingLoading = false; }
    );
  }

  close() {
    this.closed.emit();
  }

  viewDoc(doc: any) {
    if (doc.url || doc.link) {
      window.open(doc.url || doc.link, '_blank');
    }
  }

  downloadDoc(doc: any) {
    if (doc.url || doc.link) {
      const a = document.createElement('a');
      a.href = doc.url || doc.link;
      a.download = doc.name || 'document';
      a.click();
    }
  }

  downloadAll() {
    (this.challenge.documents || []).forEach((doc: any) => this.downloadDoc(doc));
  }

  setTime(date: any) {
    return new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate());
  }

  formatDate(date: any) {
    return `${this.months[date.substring(5, 7).replace(/^0+/, '') - 1]} ${date.substring(8, 10).replace(/^0+/, '')}, ${date.substring(0, 4)}`;
  }

  getStatus(check: any, completedBy: any, creationDate: any, startDate: any) {
    var lang = localStorage.getItem('selectedLanguage');
    let value;
    const createdDate = this.setTime(creationDate.split('T')[0]);
    const startOn = this.setTime(startDate.split('T')[0]);
    const completeByDate = this.setTime(completedBy.split('T')[0]);
    const currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (lang == 'Korean') {
      value = '열다';
      if (!check && isExpired) { value = '닫은'; }
      if (creationOn && pending) { value = '대기 중'; }
      if (check) { value = ''; }
    } else if (lang == 'Japanese') {
      value = '開いた';
      if (!check && isExpired) { value = '閉まっている'; }
      if (creationOn && pending) { value = '保留中'; }
      if (check) { value = ''; }
    } else {
      value = 'Open';
      if (!check && isExpired) { value = 'Closed'; }
      if (creationOn && pending) { value = 'Pending'; }
      if (check) { value = ''; }
    }
    return value;
  }

  ngOnInit() {
  }

}
